<template>
  <div class="priceInput">
    <div class="form-group">
      <p>{{ $t('Web.system_electricity_price_per_kw') }}</p>
      <input
        type="number"
        v-model="value"
        step="0.01"
        @blur="isInputActive = false"
        @focus="isInputActive = true"
      />
      <span>€</span>
    </div>
    <button @click="savePrice(innerValue)">
      {{ $t('Web.system_electricity_price_per_kw_button') }}
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

const DEFAULT_PRICE = 0.3;
const MIN_VALUE = 0.01;
const MAX_VALUE = 1.0;
const TOASTED_CONFIG = {
  singleton: true,
  duration: 1000 * 7,
  position: 'bottom-center',
  fullWidth: true
};

export default {
  name: 'PriceInput',
  data() {
    return {
      innerValue: DEFAULT_PRICE,
      isInputActive: false
    };
  },
  created() {
    this.innerValue = this.electricityPrice || DEFAULT_PRICE;
  },
  computed: {
    ...mapGetters(['profile', 'electricityPrice']),

    value: {
      get() {
        return this.innerValue;
      },
      set(newVal) {
        this.innerValue = newVal;
      }
    }
  },
  methods: {
    ...mapActions(['setElectricityPrice', 'getProfile', 'updateProfile']),
    getProfileObject() {
      return {
        ...this.profile,
        electricity_price: this.profile.electricity_price
      };
    },
    updateProfilePrice() {
      console.log('INPUT VALUE', this.profile);
      this.profile.electricity_price = this.value;

      Promise.all([this.updateProfile(this.$sanitize(JSON.stringify(this.profile)))]).then(() => {
        this.$store.dispatch('setElectricityPrice', this.value);
      });
    },
    savePrice(price) {
      this.$toasted.clear();
      price = Number(price).toFixed(2);

      if (price < MIN_VALUE || price > MAX_VALUE || isNaN(price)) {
        this.$toasted.global.jlToastError({
          message: this.$t('Web.system_electricity_price_error', [
            this.$n(MIN_VALUE, 'currency'),
            this.$n(MAX_VALUE, 'currency')
          ])
        });
      } else {
        this.updateProfilePrice();

        this.value = price;
        this.$toasted.show(
          this.$t('Web.system_electricity_price_saved', [this.$n(this.value, 'currency')]),
          TOASTED_CONFIG
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.priceInput {
  border-radius: 8px;
  background-color: hsla(0, 0%, 100%, 0.6);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  border: 0.5px solid $cloudy-blue;
  display: flex;
  width: 328px;
  padding: 16px;

  .form-group {
    text-align: left;
    flex: 1;

    p {
      @include textSmall;
      color: $bluey-grey;
    }

    input {
      border: none;
      text-align: right;
      padding: 10px 0 0 18px;
      @include textCharts;
      color: $petrol;
      width: 40px;

      &[type='number'] {
        border: none;
        box-shadow: none;
      }
    }

    span {
      padding-left: 3px;
      @include textCharts;
      color: $petrol;
    }
  }

  button {
    width: auto;
    background-color: $greeny-blue;
    color: white;
    align-self: flex-end;
    min-width: 78px; // keep button size after text change
  }
}
</style>
